import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { supportedLngs } from '~/i18nConfig.ts';
import type { Language } from '~/common/types/language.ts';

export function useRootPath() {
  let { lang } = useParams();
  const { i18n } = useTranslation();

  const isValid = supportedLngs.includes(lang as Language);

  if (!isValid) {
    lang = i18n.language;
  }

  return { rootPath: `/${lang}/` };
}
